<template>
    <div class="background">
        <div>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Top/>
                </el-col>
            </el-row>
            <el-row class="row-main">
                <el-col :span="3" :offset="5" class="col-main">
                    <div class="div-main">
                        <Aside/>
                    </div>
                </el-col>
                <el-col :span="11" class="col-main">
                    <div class="div-main">
                        <h3>联系我们</h3>
<pre>
        
办公中心：江苏省南京市溧水区晶桥镇蒲杜路8号1栋1层

联系电话：025-69967988

</pre>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Footer/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import Top from './Top';
import Aside from './Aside';
import Footer from './Footer';
export default {
    name : 'ContactUs',
    components: {
        'Top' : Top,
        'Aside' : Aside,
        'Footer' : Footer
    },
}
</script>
<style lang="scss" scoped>
/** 主组件DIV背景,高度铺满页面主DIV */
.background{
    height: 100%;
    // background: url('https://bing.biturl.top/?resolution=1920&format=image&index=0&mkt=zh-CN');
}
.background>div{
    background-color:  rgba(255, 255, 255, 0.5);
    height: 100%;
}
/deep/ .el-drawer__header span:focus {
    outline: 0;
}
/deep/ .el-drawer{
    overflow: scroll
}
.el-link{
    font-size: 20px;
}
.row-main{
    height: 80%;
    margin: 10px auto;
}
.col-main,.div-main{
    height: 100%;
}
.div-main{
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    background-color:  rgba(255, 255, 255, 0.9);
    border-radius: 4px;
}
pre{
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/ContactUs.vue